/* istanbul ignore file */

export async function loadPolyfillsIfNeeded() {
  await loadArrayAtPolyfill();
  await loadToSortedPolyfill();
}

async function loadArrayAtPolyfill() {
  if (!Array.prototype.at) {
    try {
      await import('core-js/actual/array/at');
      // eslint-disable-next-line no-console
      console.log('Array.at polyfill loaded');
    } catch (error) {
      console.error('Failed to load Array.at polyfill:', error);
    }
  }
}

async function loadToSortedPolyfill() {
  if (!Array.prototype.toSorted) {
    try {
      await import('core-js/actual/array/to-sorted');
    } catch (error) {
      console.error('Failed to load Array.toSorted polyfill:', error);
    }
  }
}
